module.exports = __webpack_public_path__ + "img/audio-wave.38a1636b.png";